import { render, staticRenderFns } from "./WorkSidebar.vue?vue&type=template&id=9eb8b028&scoped=true"
import script from "./WorkSidebar.vue?vue&type=script&lang=js"
export * from "./WorkSidebar.vue?vue&type=script&lang=js"
import style0 from "./WorkSidebar.vue?vue&type=style&index=0&id=9eb8b028&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9eb8b028",
  null
  
)

export default component.exports